import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  selectTemplateField,
  removeTemplateField,
  fetchExtractedData,
  duplicateTemplateField,
  fetchEdgesFromWords,
} from "../../../../redux/reducers/TemplateField";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FieldsNoData } from "./FieldsNoData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTooltip } from "../../../../hoc/withTooltip";
import orderBy from "lodash/orderBy";
import ClipLoader from "react-spinners/ClipLoader";
import { EdgeType } from "../../../../docuclipper/DocuclipperTypes";
import uuidv4 from "uuid/v4";

type Props = {};

const ButtonWithTT = withTooltip(Button);
export const FieldList: React.SFC<Props> = () => {
  const {
    templateFields,
    selectedFieldId,
    canvasMode,
    page,
    job,
    template,
  } = useSelector((state: ReduxState) => state.TemplateField);

  let sortedTemplateFields = orderBy(templateFields, "name");
  const dispatch = useDispatch();

  const colWidth = canvasMode === "viewExtractedData" ? 12 : 9;

  if (canvasMode === "viewExtractedData" && job.loading) {
    return <ClipLoader loading={true} />;
  }

  if (canvasMode === "rectangles" && template.loading) {
    return <ClipLoader loading={true} />;
  }

  return (
    <>
      {/* <div className="h5">Fields</div> */}
      {/* <p>Selected field: {selectedFieldId}</p> */}
      {sortedTemplateFields.length === 0 && <FieldsNoData />}
      {sortedTemplateFields.length > 0 && (
        <Row className="d-flex justify-content-between align-items-center">
          <Col xs={colWidth}>
            <Form.Control
              className="input--field-list"
              as="select"
              value={selectedFieldId || ""}
              onChange={(e) => {
                dispatch(selectTemplateField({ id: e.target.value }));

                if (canvasMode === "rectangles") {
                  dispatch(
                    fetchExtractedData({
                      id: e.target.value,
                      pageNumber: page.page?.pageNumber,
                    })
                  );
                  for (const edge of ["top", "bottom", "left", "right"]) {
                    dispatch(
                      fetchEdgesFromWords({
                        id: e.target.value,
                        edge: edge as EdgeType,
                      })
                    );
                  }
                }
              }}
            >
              {sortedTemplateFields.map((tf, i) => (
                <option
                  value={tf.id}
                  key={i}
                  // selected={tf.id === selectedFieldId}
                >
                  {tf.name || `Field ${i + 1}`}
                </option>
              ))}
            </Form.Control>
          </Col>
          {canvasMode === "rectangles" && (
            <Col xs="3" className="text-right">
              <Row>
                <ButtonWithTT
                  className="mr-1 btn-sm"
                  id="deleteFieldBtn"
                  renderTooltip={() => <span>Duplicate field</span>}
                  placement="left"
                  variant="secondary"
                  onClick={() => {
                    if (selectedFieldId) {
                      const newId = uuidv4();
                      dispatch(
                        duplicateTemplateField({
                          id: selectedFieldId,
                          newId,
                        })
                      );
                      dispatch(selectTemplateField({ id: newId }));
                    }
                  }}
                >
                  <FontAwesomeIcon icon="copy" />
                </ButtonWithTT>
                <ButtonWithTT
                  className="btn-sm"
                  id="deleteFieldBtn"
                  renderTooltip={() => <span>Delete field</span>}
                  placement="left"
                  variant="secondary"
                  onClick={() => {
                    if (selectedFieldId) {
                      dispatch(removeTemplateField({ id: selectedFieldId }));
                    }
                  }}
                >
                  <FontAwesomeIcon icon="trash" />
                </ButtonWithTT>
              </Row>
            </Col>
          )}
        </Row>
      )}
    </>
  );
};
export default FieldList;
